module.exports = __webpack_public_path__ + "static/media/Door2_After.84ac7878.jpg";